import { FormElement, Field } from '@progress/kendo-react-form';
import { Label } from '@progress/kendo-react-labels';
import { Checkbox, TextArea } from '@progress/kendo-react-inputs';
import { DatePicker, DateTimePicker } from '@progress/kendo-react-dateinputs';
import { SchedulerFormEditorProps } from '@progress/kendo-react-scheduler';
import { ActivityEditor, EmployerEditor, } from './Editor';
import { useEffect, useState } from 'react';
import { AppConstants } from '../Shared/Constants/AppConstant';
import moment from 'moment';

export const CustomFormEditor = (props: SchedulerFormEditorProps, activityList: any, employerList: any, showRecurrenceEditor: any, dairyActivityList: any, dataItem: any) => {
    const [datePicker, setDatePicker] = useState<any>(DateTimePicker);
    const [datePickerFormat, setDatePickerFormat] = useState<any>("dd/MM/yyyy HH:mm");
    const [isAllDayCheckbox, setIsAllDayCheckbox] = useState(false);
    const [isOnDutyCheckbox, setIsOnDutyCheckbox] = useState(false);
    const [isDutyOnCallCategorySelected, setIsDutyOnCallCategorySelected] = useState(false);
    const [isDutyOnCallCategorySelectedWhenDCCORICCActivityExists, setIsDutyOnCallCategorySelectedWhenDCCORICCActivityExists] = useState(false);
    //var currentDate = dataItem.start;
    //const startRecurrence = new Date(Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 0, 0, 0));
    const [recurrenceStartDate, setRecurrenceStartDate] = useState(dataItem.start);

    const intersects = (
        startTime1: Date,
        endTime1: Date,
        startTime2: Date,
        endTime2: Date
    ) =>
        (startTime1 < startTime2 && endTime1 > endTime2) ||
        (startTime2 <= startTime1 && startTime1 < endTime2) ||
        (startTime2 < endTime1 && endTime1 <= endTime2);

    //To change date-formate on change of is all day event
    const setPickerType = (value: any) => {
        if (value) {
            setDatePicker(DatePicker);
            setDatePickerFormat("dd/MM/yyyy");
        } else {
            setDatePicker(DateTimePicker);
            setDatePickerFormat("dd/MM/yyyy HH:mm");
        }
    }

    //On activity change
    const onActivityChange = (value: any) => {
        //To get selected activity details
        let selectedActivity = activityList.filter((x: any) => x.jobSubCategoryId == value)[0];
        //To check isAllDay checkbox
        let isShowAllDay = (selectedActivity?.jobCategoryShortName === AppConstants.dutyDaySubCategoryName || selectedActivity?.jobCategoryShortName === AppConstants.leaveSubCategoryName);
        setIsAllDayCheckbox(isShowAllDay);
        setPickerType(isShowAllDay);
        props.onChange("isAllDay", { value: isShowAllDay });
        //To check isOnDuty checkbox
        if (selectedActivity?.jobCategoryShortName === AppConstants.dccActivtyShortName || selectedActivity?.jobCategoryShortName === AppConstants.iccActivtyShortName) {
            setIsOnDutyCheckbox(true);
            //Checking any dutyday activity exits or not
            let isDutyDayExist = (dairyActivityList.filter((x: any) => x.jobSubCategoryName == AppConstants.dutyDaySubCategoryName && (x.id != props.valueGetter('id'))
                && intersects(props.valueGetter('start'), props.valueGetter('end'), x.start, x.end))).length > 0;
            props.onChange("isOnDuty", { value: isDutyDayExist });
        } else {
            setIsOnDutyCheckbox(false);
            props.onChange("isOnDuty", { value: false });
        }
        if (selectedActivity.jobSubCategoryId == AppConstants.dutyOnCallSubCategoryIdForactivitydropdown) {
            setIsDutyOnCallCategorySelected(true)
        } else {
            setIsDutyOnCallCategorySelected(false)
        }
        //Calling the method to check any dcc/icc activity exists
        checkDCCOrICCActivityExistsWhenDutyOncallSelected();
    }

    const isValidDailyRecurrence = (rule: string) => {
        const pattern = "FREQ=DAILY;WKST=MO";
        return pattern == rule;
    }

    const isValidWeeklyRecurrence = (rule: string, currentDay: any) => {
        const pattern = `FREQ=WEEKLY;BYDAY=${currentDay};WKST=MO`;
        return pattern == rule;
    }

    function isValidMonthlyRecurrence(rule: string, currentDate: any): boolean {
        const pattern = `FREQ=MONTHLY;BYMONTHDAY=${currentDate};WKST=MO`;
        return pattern == rule;
    }

    function isValidYearlyRecurrence(rule: string, currentMonth: any, currentDate: any): boolean {
        const pattern = `FREQ=YEARLY;BYMONTH=${currentMonth};BYMONTHDAY=${currentDate};WKST=MO`;
        return pattern == rule;
    }

    //While updating activty checking for isOnDuty and isAllDay
    useEffect(() => {
        if (props.valueGetter('id')) {
            let selectedActivity = activityList.filter((x: any) => x.jobSubCategoryId == props.valueGetter('jobSubCategoryId'))[0];
            let isShowAllDay = (selectedActivity?.jobCategoryShortName === AppConstants.dutyDaySubCategoryName || selectedActivity?.jobCategoryShortName === AppConstants.leaveSubCategoryName);
            setIsAllDayCheckbox(isShowAllDay);
            let isAllDay = props.valueGetter('isAllDay');
            setPickerType(isAllDay);
            props.onChange("isAllDay", { value: isAllDay });

            let isShowDutyOnCall = (selectedActivity?.jobCategoryShortName === AppConstants.dccActivtyShortName || selectedActivity?.jobCategoryShortName === AppConstants.iccActivtyShortName);
            setIsOnDutyCheckbox(isShowDutyOnCall);
            props.onChange("isOnDuty", { value: props.valueGetter('isOnDuty') });
            setIsDutyOnCallCategorySelected(props.valueGetter('jobSubCategoryId') == AppConstants.dutyOnCallSubCategoryIdForactivitydropdown);
            //Calling the method to check any dcc/icc activity exists
            checkDCCOrICCActivityExistsWhenDutyOncallSelected();
        }

        const endRule = document.querySelectorAll('input[type="tel"][id="k-endrule-after"]')[0];
        if (endRule) {
            endRule.setAttribute('maxLength', '2');
        }

        const intervalEditor = document.querySelectorAll('input[type="tel"][id="interval-editor"]')[0];
        if (intervalEditor) {
            intervalEditor.setAttribute('maxLength', '2');
        }

        //TODO: 
        let startTime = props.valueGetter('start');
        //setRecurrenceStartDate(startTime);

        const neverRadioButton = document.querySelector('input[type="radio"][value="never"]');
        if (neverRadioButton && neverRadioButton.parentElement) {
            neverRadioButton.removeAttribute("checked");
            neverRadioButton.parentElement.style.display = 'none';
        }

        console.log(props.valueGetter('recurrenceRule'));
        const currentDay: string = moment(startTime).format('dd').toUpperCase();
        const currentDate: number = moment(startTime).date();
        const currentMonth: number = moment(startTime).month() + 1;

        const countOccurrenceButton = document.querySelector('input[type="radio"][value="count"]');

        if (countOccurrenceButton) {
            countOccurrenceButton.setAttribute("checked", "true");
            let recurrenceRule = props.valueGetter('recurrenceRule');

            if (recurrenceRule.includes("FREQ=DAILY") && isValidDailyRecurrence(recurrenceRule)) {
                props.onChange("recurrenceRule", { value: "FREQ=DAILY;COUNT=1;WKST=MO" });
            } else if (recurrenceRule.includes("FREQ=WEEKLY") && isValidWeeklyRecurrence(recurrenceRule, currentDay)) {
                let recurrenceRule = `FREQ=WEEKLY;COUNT=1;BYDAY=${currentDay};WKST=MO`;
                props.onChange("recurrenceRule", { value: recurrenceRule });
            } else if (recurrenceRule.includes("FREQ=MONTHLY") && isValidMonthlyRecurrence(recurrenceRule, currentDate)) {
                let recurrenceRule = `FREQ=MONTHLY;COUNT=1;BYMONTHDAY=${currentDate};WKST=MO`;
                props.onChange("recurrenceRule", { value: recurrenceRule });
            } else if (recurrenceRule.includes("FREQ=YEARLY") && isValidYearlyRecurrence(recurrenceRule, currentMonth, currentDate)) {
                let recurrenceRule = `FREQ=YEARLY;COUNT=1;BYMONTH=${currentMonth};BYMONTHDAY=${currentDate};WKST=MO`;
                props.onChange("recurrenceRule", { value: recurrenceRule });
            }
        }
    }, [props.valueGetter('recurrenceRule')]);

    //If user selects duty/on-call activity and checking any dcc/icc activity exists or not,if exists showing the text message info 
    const checkDCCOrICCActivityExistsWhenDutyOncallSelected = () => {
        let currentActivity = props.valueGetter('jobSubCategoryId'); 
        let currentRecurrenceRule = props.valueGetter('recurrenceRule');
        // For normal activites
        if (currentActivity == AppConstants.dutyOnCallSubCategoryIdForactivitydropdown && !currentRecurrenceRule) {
            let currentActivityStart = props.valueGetter('start');
            let currentActivityEnd = props.valueGetter('end');
            let currentActivityIsAllDay = props.valueGetter('isAllDay');
            let currentId = props.valueGetter('id');
            let currentMemberEmployerId = props.valueGetter('memberEmployerId');
            let selectedActivityStart = currentActivityIsAllDay ? new Date(currentActivityStart.getFullYear(), currentActivityStart.getMonth(), currentActivityStart.getDate(), 0, 0, 0) : currentActivityStart;
            let selectedActivityEnd = currentActivityIsAllDay ? new Date(currentActivityEnd.getFullYear(), currentActivityEnd.getMonth(), currentActivityEnd.getDate(), 23, 59, 59) : currentActivityEnd;
            if (dairyActivityList.filter((x: any) => x.id != currentId
                                            && x.memberEmployerId == currentMemberEmployerId
                                            && (x.jobCategoryId == AppConstants.DCC_Category_Id || x.jobCategoryId == AppConstants.ICC_Category_Id))
                                           .some((x: any) => intersects(selectedActivityStart, selectedActivityEnd, x.start, x.end)))
            {
                setIsDutyOnCallCategorySelectedWhenDCCORICCActivityExists(true);
            } else {
                setIsDutyOnCallCategorySelectedWhenDCCORICCActivityExists(false);
            }
        } else{
            setIsDutyOnCallCategorySelectedWhenDCCORICCActivityExists(false);
        }
    }

    //On employer change
    const onEmployerChange = (value: any) => {
        if (value) {
            //Calling the method to check any dcc/icc activity exists
            checkDCCOrICCActivityExistsWhenDutyOncallSelected();
        }
    }

    //On stat change
    const onStartDateChange = (event: any) => {
        if (event.value) {
            var currentDate = event.value;
            setRecurrenceStartDate(currentDate);
            //Calling the method to check any dcc/icc activity exists
            checkDCCOrICCActivityExistsWhenDutyOncallSelected();
        }
    }

    //On end change
    const onEndDateChange = (event: any) => {
        if (event.value) {
            //Calling the method to check any dcc/icc activity exists
            checkDCCOrICCActivityExistsWhenDutyOncallSelected();
        }
    }

    //On all-day checkbox event change
    const onAllDayCheckBoxChange = (value: any) => {
        setPickerType(value);
        //Calling the method to check any dcc/icc activity exists
        checkDCCOrICCActivityExistsWhenDutyOncallSelected();
    }

    //On reccurence editor change
    const onReccurenceEditorChange = (e: any) => {
        //Calling the method to check any dcc/icc activity exists
        checkDCCOrICCActivityExistsWhenDutyOncallSelected();
    }

    return (
        <>
            {props.errors.activityConflictsError && <span className="help-block m-b-none text-danger field-validation-valid">{props.errors.activityConflictsError}</span>}
            <FormElement className="activityForm mt-1" horizontal={true}>
                <div className="k-form-field">
                    <Label className="text-start labelAlign">Employer /Practice</Label>
                    <div className="k-form-field-wrap">
                        <Field name={'memberEmployerId'} component={(props) => EmployerEditor(props, employerList)} onChange={(e) => onEmployerChange(e.value)} />
                        {/*{props.errors.memberEmployerId && <span className="help-block m-b-none text-danger field-validation-valid">{props.errors.memberEmployerId}</span>}*/}
                    </div>
                </div>
                <div className="k-form-field">
                    <Label className="labelAlign">Activity</Label>
                    <div className={isDutyOnCallCategorySelected ? "k-form-field-wrap dutyoncallselect" : "k-form-field-wrap"} >
                        <Field name={'jobSubCategoryId'} component={(props) => ActivityEditor(props, activityList)} onChange={(e) => onActivityChange(e.value)} />
                        {isDutyOnCallCategorySelected && (
                            <div className="mt-1 textcolor">
                                <span >Will show duty/on-call period in your diary. Actual work can be added as separate activities during this period.</span>
                            </div>
                        )}
                        {isDutyOnCallCategorySelectedWhenDCCORICCActivityExists && (
                            <div className="mt-1 textcolor">
                                <span >You have existing activities at the same time as the duty/on-call period. Ensure they are updated to 'Work carried out while on duty/on-call'.</span>
                            </div>
                        )}
                    </div>
                </div>
                <div className="k-form-field">
                    <Label className="labelAlign">Start</Label>
                    <div className="k-form-field-wrap">
                        <div>
                            <Field
                                name={'start'}
                                component={props.startEditor || datePicker}
                                as={datePicker}
                                rows={1}
                                onChange={(e) => onStartDateChange(e)}
                                format={datePickerFormat}
                                adaptive={true}
                            />
                            {props.errors.start && <span className="help-block m-b-none text-danger field-validation-valid">{props.errors.start}</span>}
                        </div>
                    </div>
                </div>
                <div className="k-form-field">
                    <Label className="labelAlign">End</Label>
                    <div className="k-form-field-wrap">
                        <Field
                            name={"end"}
                            component={props.endEditor || datePicker}
                            as={datePicker}
                            rows={1}
                            onChange={(e) => onEndDateChange(e)}
                            format={datePickerFormat}
                            adaptive={true}
                        />
                        {props.errors.end && <span className="help-block m-b-none text-danger field-validation-valid">{props.errors.end}</span>}
                    </div>
                </div>
                <div className="k-form-field">
                    <Label className="labelAlign">Notes</Label>
                    <div className="k-form-field-wrap">
                        <Field name={"notes"} component={TextArea} rows={3} />
                        {props.errors.notes && <span className="help-block m-b-none text-danger field-validation-valid">{props.errors.notes}</span>}
                    </div>
                </div>
                {showRecurrenceEditor && <Field name={"recurrenceRule"} component={props.recurrenceEditor || ''} start={recurrenceStartDate} onChange={(e) => onReccurenceEditorChange(e)} />}
                {isAllDayCheckbox && <div className="k-form-field">
                    <label id="k-is-allday-checkbox" className="text-start labelAlign k-label k-checkbox-label">All Day Event</label>
                    <div className="float-start d-flex flex-row k-form-field-wrap">
                        <Field name={"isAllDay"} component={props.allDayEditor || Checkbox} rows={1} onChange={(e) => onAllDayCheckBoxChange(e.target.value)} />
                    </div>
                </div>}
                {isOnDutyCheckbox && <div className="k-form-field">
                    <label id="k-is-isOnDuty-checkbox" className="labelAlign k-label k-checkbox-label duty-on-call">Work carried out on duty/on-call</label>
                    <div className="float-start d-flex k-form-field-wrap mt-1 mx-1">
                        <Field name={"isOnDuty"} component={props.isOnDuty || Checkbox} rows={1} />
                    </div>
                </div>}
            </FormElement>
        </>
    );
};